export default "__VITE_ASSET__DdenN6UW__"